import { SkeletonServiceService } from '../../skeleton-service.service';
import { Component, ComponentFactoryResolver, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { UserManagerService } from 'src/app/providers/services/userManager/user-manager.service';
import { ConfigService } from 'src/app/providers/config/config.service';
import { OfferedLanguage } from 'src/app/interfaces/language.model';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { defaultLanguages } from 'src/app/constants/languages.constant';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  languagesOffered: Array<OfferedLanguage> = [];
  selectedLanguage: Observable<OfferedLanguage>;
  partners: any;
  window: any = window;
  @Input() isAuthentication = false;

  constructor(
    private userManagementService: UserManagerService,
    public skeletonServiceService: SkeletonServiceService,
    public config: ConfigService,
    private viewCompRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private router: Router
  ) {
    this.languagesOffered = defaultLanguages;
    this.selectedLanguage = skeletonServiceService.appLanguage$.asObservable()
  }

  get userData() {
    return this.userManagementService.userData;
  }


  get isLoggedIn() {
    return !!this.userManagementService.userData;
  }

  get isMobile() {
    return this.skeletonServiceService.isMobile();
  }

  get bonusCount() {
    return this.userData && this.userData.balances['bon'] ? this.userData.balances.bon.length : 0;
  }

  get useAccCode() {
    return this.userManagementService.userData.isQuickSignup && !(this.userManagementService.userData.first_name && this.userManagementService.userData.last_name)
  }
  ngOnInit() {
    setInterval(() => {
      this.skeletonServiceService.currentTime = new Date();
    }, 10000);
     this.config.configsLoad$.subscribe(res => {
      if (res) {
        this.loadPartners();
      }
    })

  }
  loadPartners() {
    this.userManagementService.loadActivePartners().then(res => {
      this.partners = this.userManagementService.partners;
    });

  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    // this.selectedLanguage = this.languagesOffered.filter((lang) => {
    //   if (this.userManagementService.userData) {
    //     return lang.code === this.userManagementService.userData.lang;
    //   } else {
    //     return lang.code === 'fr';
    //   }
    // })[0];

  }
  selectLanguage(lang) {
    this.skeletonServiceService.changeAppLanguage(lang);
    // this.selectedLanguage = lang;
  }
  openSideMenu() {
      const alertCompFactory = this.componentFactoryResolver.resolveComponentFactory(NavMenuComponent);
      const navMenuComponent = this.viewCompRef.createComponent(alertCompFactory);

      navMenuComponent.instance.partners = this.partners;
      navMenuComponent.instance.languagesOffered = this.languagesOffered;
      // navMenuComponent.instance.selectedLanguage = this.selectedLanguage;
      navMenuComponent.instance.closeSideMenu.subscribe((res)=> {
        if(res === true){
          navMenuComponent.instance.modalState = "leave";
        }
        navMenuComponent.destroy();
    })
    navMenuComponent.instance.langChange.subscribe((res: OfferedLanguage) => {
      if (!!res) {
        this.selectLanguage(res.code)
      }
    })
  }

  disconnectUser() {
    // const param = {
    //     sessionToken: this.userManagementService.userData ? this.userManagementService.userData.session : '',
    // };
    this.userManagementService
      .logout()
      .then((data) => {
        this.router.navigate(["home"])
      }).catch((err) => { console.log(err)})
      .finally(() => {
      });
  }
}
